






































import mixins from 'vue-typed-mixins';
import RandomMixin from '@/mixins/SmartTable/RandomMixin';
import JQueryMixin from '@/mixins/SmartTable/JQueryMixin';
import { Filter } from '@/models/SmartTable/Filter';
import { State } from '@/models/SmartTable/State';
import { Column } from '@/models/SmartTable/Column';
import { SortMode } from '@/models/SmartTable/SortMode';

export default mixins(JQueryMixin, RandomMixin).extend({
  props: {
    column: Object as () => Column,
    state: Object as () => State,
    tableId: { type: String, default: 'smartTableTable' },
    localIdentifier: Number
  },
  computed: {
    hasFilter: function (): boolean {
      // @ts-ignore
      return !!this.filter;
    },
    filter: {
      get: function (): Filter | undefined {
        return this.state.filters.find((f) => f.fieldName === this.column.fieldName);
      },
      set: function (filter: Filter): void {
        if (!filter) {
          this.state.filters = this.state.filters.filter(
            (f) => f.fieldName !== this.column.fieldName
          );
          return;
        }

        let oldFilter = this.state.filters.find((f) => f.fieldName === this.column.fieldName);
        if (!oldFilter) {
          this.state.filters.push(filter);
        }
      }
    }
  },
  methods: {
    getSorting: function (): SortMode {
      const sorting = this.state.sorting.filter(
        (s) => s.sortBy.toLowerCase() === this.column.fieldName.toLowerCase()
      );
      if (sorting.length > 0) {
        return sorting[0].sortMode;
      } else {
        return 'none';
      }
    }
  }
});
